import type { ResolvedMonospaceCollection } from '#layers/data-model/public';
import { getCollectionFields, isFieldHidden, sortFieldsBySortKey } from '#layers/data-model/public';

/** Returns visible, unconstrained fields in form sort order. */
export function getCustomizableFormFields(collection: ResolvedMonospaceCollection) {
	return sortFieldsBySortKey(
		getCollectionFields(collection, { includeConstrainedFields: false })
			.filter((field) => !isFieldHidden(field)),
	);
}
